require.register("modules/m0x/a05/page-52/page-52", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page_52 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page_52;

  
});

